import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/lib/api";

const DisclaimerContext = createContext({});

// Fallbacks so disclaimers still render if the fetch is slow/unavailable.
const FALLBACK = {
  ai_analysis: "This finding was generated by AI photo comparison and may not be fully accurate. Lighting, camera angle, and image quality can affect results. Review the photos yourself and use your own judgment before relying on this classification.",
  dispute_letter: "This is a document-preparation tool, not legal advice. Review the bracketed placeholders and fill in your local details.",
  baseline_agreement: "This acknowledgment is a shared record between you and your tenant; it is not legal advice.",
  deadline_tracker: "This is an informational reminder based on the deposit-return deadline date you entered yourself. TenantSeal does not supply, calculate, or verify any legal deadline. It is not legal advice — confirm your exact deadline with your lease or your local housing resources.",
  general_footer: "TenantSeal is not a law firm and does not provide legal advice.",
};

export function DisclaimerProvider({ children }) {
  const [map, setMap] = useState({});
  useEffect(() => {
    axios.get(`${API}/legal/disclaimers`).then(({ data }) => setMap(data || {})).catch(() => {});
  }, []);
  return <DisclaimerContext.Provider value={map}>{children}</DisclaimerContext.Provider>;
}

export function useDisclaimer(keyName) {
  const map = useContext(DisclaimerContext);
  return map[keyName] || FALLBACK[keyName] || "";
}

export function LegalDisclaimer({ keyName, className = "", testId }) {
  const text = useDisclaimer(keyName);
  if (!text) return null;
  return (
    <p data-testid={testId || `disclaimer-${keyName}`}
      className={className || "text-[11px] leading-relaxed text-[#94A3B8]"}>
      {text}
    </p>
  );
}
